export const FORM_CLAIM_DETAIL_PERSONAL = ({
  onEnter,
  provinceOptions,
  districtOptions,
  subDistrictOptions,
}) => {
  const span = 24;
  return [
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'addressFullText',
      label: 'ที่อยู่',
      type: 'TEXT',
      span,
    },
    {
      name: 'zipCode',
      label:
        'รหัสไปรษณีย์ *** (หากต้องการเปลี่ยนที่อยู่ให้ทำการกรอกรหัสไปรษณีย์ใหม่แล้วกด Enter) ***',
      type: 'INPUT',
      placeholder: '',
      span,
      onEnter,
    },
    {
      name: 'provinceId',
      label: 'จังหวัด',
      type: 'DROPDOWN',
      properties: {
        options: provinceOptions || [],
      },
      span,
    },
    {
      name: 'districtId',
      label: 'เขต/อำเภอ',
      type: 'DROPDOWN',
      properties: {
        options: districtOptions || [],
      },
      span,
    },
    {
      name: 'subDistrictId',
      label: 'แขวง/ตำบล',
      type: 'DROPDOWN',
      properties: {
        options: subDistrictOptions || [],
      },
      span,
    },
    {
      name: 'other',
      label: 'ที่อยู่เพิ่มเติม',
      type: 'INPUT',
      placeholder: 'เช่น บ้านเลขที่ หมู่ ซอย ถนน หรือจุดสังเกตของบ้าน',
      span,
      maxLength: 60,
      rules: {
        required: true,
        maxLength: { value: 60, message: 'ระบุไม่เกิน 60 ตัวอักษร' },
        validate: (value) =>
          !!String(value || '').trim() || 'กรุณาระบุที่อยู่เพิ่มเติม เช่น บ้านเลขที่ ซอย หรือถนน',
      },
    },
  ];
};
export const FORM_CLAIM_EDIT_DETAIL_PICTURE = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/bmp', 'image/gif'];
  return [
    {
      name: 'claimImageUrl',
      label: 'รูปภาพสินค้าเคลม (.png, .jpg, .jpeg, .bmp, .gif)',
      type: 'UPLOAD',
      accept: accept.join(','),
      listType: 'picture-card',
      span: 24,
      rules: {
        required: true,
      },
      maxCount: 1,
    },
    {
      name: 'receiptImageUrl',
      label: 'รูปภาพใบรับเงิน',
      type: 'UPLOAD',
      listType: 'picture-card',
      span: 10,
      maxCount: 1,
    },
  ];
};

export const FORM_CLAIM_DETAIL_CLAIM = ({
  breakdownList,
  showStoreField,
  channelClaimOptions,
  storeTypeClaimOptions,
}) => {
  const span = 24;

  const SHOW_STORE = [
    {
      name: 'storeId',
      label: 'ร้านค้า',
      type: 'DROPDOWN',
      properties: {
        options: storeTypeClaimOptions || [],
      },
      span,
    },
  ];

  const SHOW_DATE_SERVICE = [
    {
      name: 'bookingDate',
      label: 'วันที่บริการ',
      type: 'DATE_PICKER',
      span,
    },
  ];

  return [
    {
      name: 'claimCode',
      label: 'เลขที่การเคลม',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'claimId',
      label: 'Claim ID',
      type: 'HIDDEN',
      span,
    },
    {
      name: 'warrantyCode',
      label: 'รหัสลงทะเบียนสินค้า',
      type: 'TEXT',
      span,
    },
    {
      name: 'claimDate',
      label: 'วันที่แจ้งเคลม',
      type: 'TEXT',
      span,
    },
    {
      name: 'productName',
      label: 'ชื่อสินค้า',
      type: 'TEXT',
      span,
    },
    {
      name: 'mobileBrandName',
      label: 'ยี่ห้อ',
      type: 'TEXT',
      span,
    },
    {
      name: 'mobileModelName',
      label: 'รุ่น',
      type: 'TEXT',
      span,
    },
    {
      name: 'breakdownId',
      label: 'อาการเสีย',
      type: 'DROPDOWN',
      properties: {
        options: breakdownList || [],
      },
      span,
    },
    {
      name: 'noDeductWarranty',
      label: 'ไม่ตัดประกัน (ต้องรออนุมัติก่อนส่ง CS)',
      type: 'CHECKBOX',
      properties: {
        options: [{ label: '', value: 'Y' }],
      },
      span,
    },
    {
      name: 'remark',
      label: 'หมายเหตุ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      span,
      rules: {
        maxLength: 500,
      },
    },
    {
      name: 'channelClaimId',
      label: 'ช่องทางการเคลม',
      type: 'DROPDOWN',
      properties: {
        options: channelClaimOptions || [],
      },
      span,
    },
    ...(['FOCUS', 'STORE'].includes(showStoreField) ? SHOW_STORE : []),
    ...(showStoreField === 'FOCUS' ? SHOW_DATE_SERVICE : []),
    {
      name: 'claimedDays',
      label: 'จำนวนวันที่แจ้งเคลมมาแล้ว',
      type: 'TEXT',
      span,
    },
    {
      name: 'remainingDays ',
      label: 'จำนวนวันคงเหลือ',
      type: 'TEXT',
      span,
    },
  ];
};
